import { useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Modal.module.css';

import useBackdrop from '../../hooks/useBackdrop';

import { ModalWrapper } from '../../types/modal';

export default function Modal({
  children,
  id,
  type,
  isTerms,
  onClose,
}: ModalWrapper) {
  const cx = classNames.bind(styles);

  const modalRef = useRef<HTMLDivElement>(null);

  const isTypeConfirm = type === 'confirm';
  const layerClass = isTypeConfirm ? 'alert_layer' : 'popup_layer';

  useBackdrop({ id, type }, modalRef, { isScroll: true, onClose });

  return (
    <div className={cx('container', id)}>
      <div
        className={cx('layer', layerClass, type, { terms: isTerms })}
        ref={modalRef}
      >
        <div className={cx('inner', id)}>{children}</div>
      </div>
    </div>
  );
}
